import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

export function AdminLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const profile = useAuthStore(s => s.profile);

  return (
    <div className="min-h-dvh bg-gray-950 text-gray-100">
      {/* Header */}
      <header className="border-b border-gray-800 bg-gray-900/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-indigo-600 rounded-lg flex items-center justify-center text-sm font-bold">
              HS
            </div>
            <div>
              <h1 className="text-lg font-bold text-white">Admin Dashboard</h1>
              <p className="text-xs text-gray-500">{profile?.email}</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a
              href={import.meta.env.VITE_SENTRY_DSN ? 'https://sentry.io' : '#'}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs px-3 py-1.5 rounded-lg bg-gray-800 text-gray-300 hover:text-white hover:bg-gray-700 transition-colors"
            >
              Sentry
            </a>
            <button
              onClick={() => navigate('/')}
              className="text-xs px-3 py-1.5 rounded-lg bg-gray-800 text-gray-300 hover:text-white hover:bg-gray-700 transition-colors"
            >
              Back to App
            </button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-7xl mx-auto px-6 py-8">
        {children}
      </main>
    </div>
  );
}
